import Ticket from "../../components/Ticket"
import styles from "./TicketsPage.module.css"
import { useEffect, useState } from "react";
import FormTicket from "../../components/FormTicket";
import { deleteTicket, editTicket, editTicketStatus, getTickets } from "../../api/tickets.api";
import HeaderPage from "../../components/HeaderPage";
import MiniCardUser from "../../components/MiniCardUser";
import SearchBar from "../../components/SearchBar";
import AlertDelete from "../../components/AlertDelete";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { check } from "../../api/users.api";
import { useNavigate } from "react-router-dom";
import AlertFinish from "../../components/AlertFinish";
import ModalDataTicket from "../../components/ModalDataTicket";
import FormTicketEdit from "../../components/FormTicketEdit";
import FormTicketEditStatus from "../../components/FormTicketEditStatus";

function TicketsPage() {
    const [isOpen, setIsOpen] = useState(false)
    const [tickets, setTickets] = useState([])
    const [search, setSearch] = useState("")
    const [isOpenAlert, setIsOpenAlert] = useState(false)
    const [isOpenLook, setiIsOpenLook] = useState(false)
    const [isOpenAlertDelete, setIsOpenAlertDelete] = useState(false)
    const [isOpenEdit, setIsOpenEdit] = useState(false)
    const [ticket, setTicket] = useState("")
    const [isOpenFormEdit, setIsOpenFormEdit] = useState("")
    const [isOpenEditStatus ,setIsOpenEditStatus] = useState(false)
    function sendTicketToAlert(tick) {
        setTicket(tick);
        setIsOpenAlert(true)
    }

    function sendTicketToModal(tick) {
        setTicket(tick)
        setIsOpenEdit(true)
    }

    const navigate = useNavigate()

    useEffect(() => {
        check() 
            .then(() => {
                getTickets()
                    .then(res => setTickets(res.data.sort((a, b) => b.id - a.id)))
                    .catch((error) => {
                        setTickets([]);
                        if (error.response.status === 401) {
                            return toast.error("Não autorizado!");
                        } else if (error.response.status != 200) {
                            return toast.error("Erro! Verificar com suporte");
                        }
                    })
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    navigate("/login")
                } else if (error.response.status != 200) {
                    return toast.error("Erro! Verificar com suporte");
                }
            })
    }, [])

    const filteredTickets = Array.isArray(tickets) ? tickets.filter(ticket =>
        ticket.car.placa.toLowerCase().includes(search.toLowerCase()) ||
        ticket.dataAbertura.toLowerCase().includes(search.toLowerCase()) ||
        ticket.dataPrevisao.toLowerCase().includes(search.toLowerCase()) ||
        ticket.status.toLowerCase().includes(search.toLowerCase()) ||
        ticket.oficina.toLowerCase().includes(search.toLowerCase()) 
    ) : []

    return (
        <main className={styles.container}>
            <section className={styles.containerOne}>
                <HeaderPage
                    title="Tickets"
                    textTitle="Gerencie sua frota de veículos"
                    textBtn="Ticket"
                    setIsOpen={() => setIsOpen(true)}
                />
                <MiniCardUser
                    text="Total de Tickets"
                    data={tickets.length}
                />
                <SearchBar setSearch={setSearch} />
            </section>
            <section className={styles.cards}>
                {filteredTickets.map(tick => {
                    return <Ticket thisTicket={tick} key={tick.id} setIsOpen={sendTicketToAlert} setIsOpenEdit={sendTicketToModal} />
                })}
            </section>
            
            {isOpen && (
                <FormTicket setIsOpen={setIsOpen} setTickets={setTickets} />
            )}

            {isOpenAlert && (
                <AlertFinish setIsOpen={setIsOpenAlert} entity={ticket} func={editTicketStatus}/>
            )}

            {isOpenEdit && (
                <ModalDataTicket thisTicket={ticket} setIsOpen={setIsOpenEdit} setIsOpenDelete={setIsOpenAlertDelete} setIsOpenEdit={setIsOpenFormEdit} setIsOpenEditStatus={setIsOpenEditStatus}/>
            )}

            {isOpenAlertDelete && (
                <AlertDelete setIsOpen={setIsOpenAlertDelete} entity={ticket} func={deleteTicket}/>
            )}

            {isOpenFormEdit && (
                <FormTicketEdit setIsOpen={setIsOpenFormEdit} thisTicket={ticket}/>
            )}

            {isOpenEditStatus && (
                <FormTicketEditStatus setIsOpen={setIsOpenEditStatus} thisTicket={ticket}/>
            )}
        </main>
    )
}

export default TicketsPage;